import React from 'react';
import { Pane, PaneBackButton, PaneBody, PaneHeader } from '../../atoms/applications/page';
import { inject, observer } from 'mobx-react';
import { CreditCardInputV2 } from '../../molecules/payment/CardInput';
import { PaymentMethodSelector } from '../../molecules/applications/PaymentMethodSelector';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { MembershipPlanUpdateState } from '../../../containers/membership_plans/states/MembershipPlanUpdateState';
import { FormError } from '../../../../commonv3/components/atoms/forms/vertical';

type Props = {
  pageState: MembershipPlanUpdateState;
};

export const PaymentMethodPane = inject('pageState')(
  observer(
    class PaymentMethodPane extends React.Component<Props> {
      render() {
        const {
          pageState: {
            cardState,
            selectedPlan,
            selectedItem,
            validateCardAndNext,
            submitState: { submitting },
          },
        } = this.props;
        if (!selectedItem || !selectedPlan) {
          return null;
        }
        const { number, yy, mm, cvc } = cardState.cardFormState.fields;
        return (
          <Pane id="payment-method-pane">
            <PaneBackButton />
            <PaneHeader>お支払い方法の選択</PaneHeader>
            <PaneBody>
              <CreditCardInputV2 cardState={cardState} />
              {[number, yy, mm, cvc].map((e, i) => (
                <FormError key={i} state={e} />
              ))}
              <PaymentMethodSelector
                title={`${selectedPlan.name}${selectedItem.duration_month}ヶ月`}
                price={selectedItem.price}
                price_with_tax={selectedItem.price_with_tax}
                value={1}
                options={[1]}
              />
              <ButtonWrapper>
                <SubmitButton id="submit-button" loading={submitting} onClick={validateCardAndNext}>
                  お申し込み内容の確認へ
                </SubmitButton>
              </ButtonWrapper>
            </PaneBody>
          </Pane>
        );
      }
    }
  )
);
